<template>
  <v-row>
    <v-col cols="12" lg="12">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title class="page-title">
            Daily Activations
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="pa-4">
          <apexchart
            width="100%"
            height="350"
            type="line"
            :options="options"
            :series="series"
          ></apexchart>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
export default {
  name: "DailyActivation",
  data() {
    return {
      options: {
        chart: {
          id: "daily_activation",
        },
        xaxis: {
          categories: [],
          tickPlacement: "between",
          labels: {
            // show: true,
            // rotate: -45,
            rotateAlways: true,
          },
        },
        yaxis: {
          labels: {
            formatter: function(val) {
              return parseInt(val).toLocaleString();
            },
          },
        },

        noData: {
          text: "Loading...",
        },

        tooltip: {
          y: {
            formatter: function(value) {
              return value.toLocaleString();
            },
          },
        },
      },

      series: [
        {
          data: [],
          name: "Count",
        },
      ],
    };
  },
  methods: {
    async getDailyActivation() {
      await this.$api
        .get("/acquisition/report?report=dailyActivationGraph")
        .then((response) => {
          const res = response.data.data;
          // console.log(res);
          const newArr = res.graph.map((obj) => ({
            label: this.formatDate(obj.date),
            value: obj.total,
          }));

          newArr.map((val) => {
            this.options.xaxis.categories.push(val.label);
          });

          this.series = [
            {
              data: newArr.map((val) => val.value),
            },
          ];
        })
        .catch((e) => {
          console.log(e);
        });
    },

    formatDate(date, format = "MMM-DD") {
      return moment(date).format(format);
    },
  },
  created() {
    this.getDailyActivation();
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
